<div class="chart-title">Per Apartment Remaining 20-Year Capital Need Compared to NYCHA Average ($)</div>
<div class="chart-container">
    <canvas  id="barChart" >{{ barChart }}</canvas>
</div>
<div><app-legends-color [legendCollection]="chartLegends"></app-legends-color></div>